module.exports = __webpack_public_path__ + "img/9788983947772.737fd080.jpg";